import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { hasPermission } from "../../utils/hasPermission";

const RequirePermission = ({ permission, children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("userData"));
    setUser(storedUser);
  }, []);

  if (user === null) {
    return <div>Loading...</div>; // Or a spinner component
  }

  if (!hasPermission(user, permission)) {
    return <Navigate to="/error-403" />;
  }

  return children;
};

export default RequirePermission;
